import { Component, HostListener, OnInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { BaseComponent } from '@base/base.component';
import { EnumProductType } from '@enums/productsType';
import { Criteria } from '@models/awardPrograms/awardProgram';
import { AwardProgramProductTypeResponse, GetAwardProgramPanelResponse, GetPanelRequest } from '@models/awardPrograms/awardProgramPanel';
import { AwardProgramService } from '@services/award-program.service';
import { finalize } from 'rxjs';
import { orderBy } from 'lodash-es';
import { PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM } from 'src/app/const/permitions';
import { EnumPath } from '@enums/path';

@Component({
  selector: 'app-summary-award-program',
  templateUrl: './summary-award-program.component.html',
  styleUrl: './summary-award-program.component.scss'
})
export class SummaryAwardProgramComponent extends BaseComponent implements OnInit {
  @HostListener('click', ['$event'])
  public handleShouldOpenPanel(event: PointerEvent) {
    const target = event.target as HTMLElement;

    const elementIncludesMaterialClass = target.className.includes('mat-');

    if (elementIncludesMaterialClass) {
      return;
    }

    this.router.navigate([EnumPath.CONSORTIUM_RELATIONSHIP_PANEL], { state: { awardProgram: { chosedCriteria: null, selectedAwardProgramId: this.awardProgramModel} } });
  }


  public chosedCriteria: Criteria;

  productType: EnumProductType;
  public awardPrograms: AwardProgramProductTypeResponse[];
  selectedAwardProgramId: number;
  public awardProgramPanel: GetAwardProgramPanelResponse;
  public classifiersHeaders: string[];
  private charts: any[] = [];
  public isLoading: boolean = false;
  public placeHolderCombo: string = 'Selecione';

  public awardProgramModel: number;

  get hasPermissionReadCriteria(): boolean {

    switch(this.productType){
      case EnumProductType.consortium: return this.hasPermissionReadCriteriaConsortium;
      default: return true;
    }

  }

  get hasPermissionReadCriteriaConsortium(): boolean {
    return this.getPermissions()
               .some(p => [PERMITION_CONSORTIUM_READ_CRITERIA_CONSORTIUM].includes(p));
  }

  get chartListLength(): number {
    return this.charts.length
  }

  constructor(private awardProgramService: AwardProgramService) {
    super();
  }

  ngOnInit(): void {
    this.placeHolderCombo = "Carregando...";
    this.checkProductType();

    this.awardProgramService.getAwardProgramsByProductType(this.productType)
    .pipe(
      finalize(() => {
        this.placeHolderCombo = 'Selecione';
      })
    )
    .subscribe((response) => {
      this.awardPrograms = response;
      this.awardProgramModel = orderBy(this.awardPrograms, ['id'], ['asc'])[0].id;
      this.onAwardProgramChange({value: this.awardProgramModel})
    });

  }

  private checkProductType(): void {
    this.productType = EnumProductType.consortium;
  }


  onAwardProgramChange(event: Partial<MatSelectChange>): void {

    this.isLoading = true;
    this.selectedAwardProgramId = event.value;
    const acessPoint= this.getAccessPoint();
    let dealerId;
    let economicGroupId;
    if(acessPoint.isEconomicGroup){
      economicGroupId = acessPoint.id;
    } else{
      dealerId = acessPoint.id;
    }
    const request: GetPanelRequest = {
      awardProgramId: this.selectedAwardProgramId,
      economicGroupId: economicGroupId,
      dealerId: dealerId
    };
    this.awardProgramService.getPanel(request)
  .pipe(
    finalize(() => {
      this.isLoading = false;
    })
  )
  .subscribe((response: GetAwardProgramPanelResponse) => {
    this.awardProgramPanel = response;
    this.classifiersHeaders = Array.from(
      new Set(
        this.awardProgramPanel.criteriasClassifiers
          .flatMap(c => c.criteriaValues?.classifiers?.map(cl => cl.description) || [])
      )
    );
    });
  }

  public selectAwardProgramCriteriaData(criteria: Criteria): void {
    if(this.hasPermissionReadCriteria){
      this.chosedCriteria = criteria
    }

    this.router.navigate([EnumPath.CONSORTIUM_RELATIONSHIP_PANEL], { state: { awardProgram: { chosedCriteria: this.chosedCriteria, selectedAwardProgramId: this.selectedAwardProgramId } } })
  }
}


